'use strict';

angular.module('mean.general-tasks').factory('Materials', ['$resource',
  function($resource) {
    return $resource('/api/materials/:materialId', {
      materialId: '@_id'
    }, {
    	update: {
    		method: 'PUT'
    	},
        bulkAdd: {
            method: 'POST',
            isArray: true
        },
        bulkDelete: {
            method: 'DELETE',
            isArray: true
        }
    });
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/general-tasks/public/services/materials.js